export default __webpack_public_path__ + "70f6571f3513f087ae8f54de4d5bc839.png";